var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"pos-content-container",attrs:{"data-scrollbar":"true","data-height":"100%","data-skip-mobile":"true"}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }